const DEFAULT_LOCALE = "en-ZA";

const homeMessages = {
  "en-ZA": {
    assettoCorsaEvoChampionshipLeaders: "Assetto Corsa EVO Championship Leaders",
  },
};

export function getHomeMessages(locale = DEFAULT_LOCALE) {
  return homeMessages[locale] ?? homeMessages[DEFAULT_LOCALE];
}
